import { useNavigate } from "react-router-dom";
import { useGetDrawingToolData, usePutDrawingToolDataToQueue } from "../../../../api/drawingTool";
import { MappingSourceType } from "../../../../config/enums/MappingSourceType.enum";
import useUploadMappingImage from "../../../../hooks/useUploadMappingImage";

interface UseDrawingToolLockParams {
  mappingSourceType: MappingSourceType;
  sourceId: string | undefined;
  ownerId: string | undefined;
  isAverageProduct: boolean;
}

/** Drawing-tool lock status, image upload, and the calculate-queue/navigation flow that
 * follows it. */
export const useDrawingToolLock = ({
  mappingSourceType,
  sourceId,
  ownerId,
  isAverageProduct
}: UseDrawingToolLockParams) => {
  const navigate = useNavigate();

  const { isLoading: isLoadingPutDataToQueue, mutate: putDrawingToolDataToQueueAsync } =
    usePutDrawingToolDataToQueue(mappingSourceType);
  const { data: drawingToolData, isLoading: isDrawingToolLoading } = useGetDrawingToolData(
    mappingSourceType,
    sourceId,
    ownerId
  );
  const isLocked = !!drawingToolData?.lockStatus;
  const [isLoadingImageUpload, uploadImage] = useUploadMappingImage(
    drawingToolData?.chartNodes || [],
    mappingSourceType
  );

  const cancel = () => navigate(`/mapping/${mappingSourceType}?sourceId=${sourceId}`);

  const uploadMappingImage = () => {
    if (!sourceId || !ownerId) return;
    uploadImage(sourceId, ownerId, () => {});
  };

  const navigateAndUploadImage = () => {
    uploadMappingImage();
    navigate(
      `/product-summary?salesUnitId=${sourceId}&productId=${ownerId}&isAverageProduct=${isAverageProduct}`
    );
  };

  // Called when the user confirms the calculation modal
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const calculateHandleApprove = () => {
    putDrawingToolDataToQueueAsync(drawingToolData, {
      onError: () => cancel(),
      onSuccess: () => navigateAndUploadImage()
    });
  };

  return {
    drawingToolData,
    isDrawingToolLoading,
    isLocked,
    isLoadingImageUpload,
    isLoadingPutDataToQueue,
    cancel,
    navigateAndUploadImage,
    calculateHandleApprove
  };
};
